module.exports = __webpack_public_path__ + "static/img/demoacc-theme.2170b09.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/registerflow-new/demoacc-theme.svg
// module id = DS5x
// module chunks = 4